// assets
import {
  IconAlignBoxBottomCenter,
  IconSitemap,
  IconBaselineDensitySmall,
  IconCoin,
  IconAdjustments,
  IconApi,
  IconGardenCart,
  IconUser,
  IconUserFilled,
  IconMessageChatbot,
  IconDevices,
} from '@tabler/icons-react';

// constant
const icons = { IconAlignBoxBottomCenter, IconSitemap, IconBaselineDensitySmall, IconCoin, IconAdjustments, IconApi, IconMessageChatbot, IconGardenCart, IconUser, IconUserFilled, IconDevices };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '用量信息',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconAlignBoxBottomCenter,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'token',
      title: 'API keys',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconApi,
      breadcrumbs: false
    },
    {
      id: 'device',
      title: '授权设备',
      type: 'item',
      url: '/panel/device',
      icon: icons.IconDevices,
      breadcrumbs: false
    },
    {
      id: 'log',
      title: '请求明细',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconBaselineDensitySmall,
      breadcrumbs: false
    },
    {
      id: 'billing',
      title: '账单统计',
      type: 'item',
      url: '/panel/billing',
      icon: icons.IconMessageChatbot,
      breadcrumbs: false
    },
    {
      id: 'topup',
      title: '账号充值',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconCoin,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: '个人信息',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserFilled,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'channel',
      title: '模型渠道',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'user',
      title: '用户管理',
      type: 'item',
      url: '/panel/user',
      icon: icons.IconUser,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'redemption',
      title: '资源充值',
      type: 'item',
      url: '/panel/redemption',
      icon: icons.IconGardenCart,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'setting',
      title: '系统设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

export default panel;
